import { render, staticRenderFns } from "./MproductIndex.vue?vue&type=template&id=9765334c"
import script from "./MproductIndex.vue?vue&type=script&lang=js"
export * from "./MproductIndex.vue?vue&type=script&lang=js"
import style0 from "./MproductIndex.vue?vue&type=style&index=0&id=9765334c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports